module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter",
    attrs: {
      "id": "c15"
    }
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }), _vm._v("Heating Things Up a Little")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('span', {
    staticClass: "dropcaps"
  }, [_vm._v("W")]), _vm._v("e’ve all heard the expression “iron out your problems,” but one eighteen-year-old bride from Andriasu, Romania, took this phrase too literally. After her husband Mircea Stoleru fell asleep without making love to her, she took matters into her own hands and burned him on the right shoulder with a hot iron. Stoleru took responsibility for his own inactions, and told reporters in July 2001, “This should serve me right. I knew what I got when I married such a young and beautiful wife, and I never get home sober.”"), _c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/Greg_9780740792069_epub_L04_r1.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "textbox"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/Greg_9780740792069_epub_L07_r1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center02"
  }, [_vm._v("At their 1990 wedding in Seysinnet-Pariset, France, Fabien Pretou, standing "), _c('span', {
    staticClass: "big01"
  }, [_vm._v("six feet two")]), _vm._v(" inches tall, towered over his "), _c('span', {
    staticClass: "big01"
  }, [_vm._v("three-feet-one-inch")]), _vm._v(" bride Natalie Lucius.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/Greg_9780740792069_epub_L03_r1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center02"
  }, [_c('span', {
    staticClass: "big01"
  }, [_vm._v("Longest marriage:")])]), _vm._v(" "), _c('p', {
    staticClass: "center02"
  }, [_vm._v("Wesley and Stella McGowen, married since February 6, 1920—more than 85 years.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("—"), _c('em', [_vm._v("Guinness World Records 2005: Special 50th Anniversary Edition")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/Greg_9780740792069_epub_L07_r1.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ad5193d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9780740792069_epub_c15_r1.vue
// module id = 117
// module chunks = 0